import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Container, Dialog, Grid, Typography } from '@mui/material';

import {
  gray100,
  gray90,
  primary10,
  primaryColor
} from '../../constants/Colors';

interface Props {
  onClose: (e: React.MouseEvent<Element, MouseEvent>) => void;
  open: boolean;
}

const styles = {
  closeIcon: {
    color: gray90,
    cursor: 'pointer',
    height: '24px',
    width: '24px'
  },
  contentTitle: {
    bgcolor: primary10,
    borderLeft: `3px solid ${primaryColor}`,
    color: gray100,
    fontSize: '18px',
    fontWeight: 500,
    height: '34px',
    lineHeight: '34px',
    mb: '16px',
    pl: '15px'
  },
  title: {
    color: gray100,
    fontSize: '22px',
    fontWeight: 500
  },
  wrapper: {
    p: '24px'
  }
};

const CustomDialog: React.FC<Props> = (props) => {
  const { onClose, open } = props;
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <Container sx={styles.wrapper}>
          <Grid
            container
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            mb={'24px'}
          >
            <Typography sx={styles.title}>建材情報について</Typography>
            <CloseIcon sx={styles.closeIcon} onClick={onClose} />
          </Grid>
          <Box>
            <Box mb={'48px'}>
              <Typography sx={styles.contentTitle}>CO2原単位</Typography>
              <Typography>
                ここで示すCO2原単位とは、この建材における
                <Typography
                  component="span"
                  sx={{ textDecoration: 'underline' }}
                >
                  単位当たりのCO2排出量
                </Typography>
                です。上段のプルダウンから、以下の３パターンを選択できます。
                <br />
                <br />
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  ①%による換算値で表示（推奨）
                </Typography>
                <br />
                ユーザー設定で定めた「CO2基準値（原単位）」から、建材メーカーが算定したCO2削減率（％）を用いて計算した値を表示します。メーカーが
                <Typography
                  component="span"
                  sx={{ textDecoration: 'underline' }}
                >
                  「CO2削減率」を設定していない建材は対象外
                </Typography>
                となり、表示されません。
                <br />
                ※[各ユーザーのCO2基準値] × [100% - CO2削減率]
                <br />
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  ②メーカー算定値で表示
                </Typography>
                <br />
                建材メーカーが算定したCO2排出原単位を使用しますCO2排出原単位を設定していない建材は、ユーザー設定で定めた「CO2基準値（原単位）」から、建材メーカーが定めたCO2削減率（％）を用いて計算した値を表示します。
                <Typography
                  component="span"
                  sx={{ textDecoration: 'underline' }}
                >
                  全建材が対象になりますが、異なるCO2原単位データベースが混在することになるため大きく誤差
                </Typography>
                が生じます。
                <br />
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  ③換算値+算定値で表示
                </Typography>
                <br />
                ①に加えて、CO2削減率を設定しておらず非表示になる建材に、建材メーカーが算定したCO2排出原単位を使用します。
                <Typography
                  component="span"
                  sx={{ textDecoration: 'underline' }}
                >
                  全建材が対象になりますが、異なるCO2原単位データベースが混在することになるため誤差
                </Typography>
                が生じます。
                <br />
                <br />
                初期設定では「①%による換算値で表示」で計算されます。
              </Typography>
            </Box>
            <Box mb={'48px'}>
              <Typography sx={styles.contentTitle}>CO2削減率</Typography>
              <Typography>
                ここで示すCO2削減率とは、一般的な建材のCO2排出量に対して、この建材の削減割合を％で示した数値です。各建材で元になるCO2原単位データベースが異なるため、メーカーが算定する際に、同じ原単位で計算した削減率で登録されています。
              </Typography>
            </Box>
            <Box mb={'48px'}>
              <Typography sx={styles.contentTitle}>メーカー算定値</Typography>
              <Typography>
                各メーカーが算定・掲示している各建材のCO2原単位（単位当たりのCO2排出量）です。CO2原単位の根拠となる既存データベース（産連表やIDEA等）は、どれを使うかは明確に決まっておらず各メーカーに委ねられています。このため各建材のCO2原単位は元のデータベースが異なるため、メーカー同士で単純に比較ができません。
                <br />
                したがって、比較の際にメーカー算定値を含めると誤差が大きく生じることに留意してください。
              </Typography>
            </Box>
            <Box mb={'48px'}>
              <Typography sx={styles.contentTitle}>CO2算定根拠</Typography>
              <Typography>
                CMCOSでは、第三者認証の種類を制限せずに登録できます。また。
                <Typography
                  component="span"
                  sx={{ textDecoration: 'underline' }}
                >
                  第三者認証を取得中、もしくは認証を取得していなくても登録可能
                </Typography>
                としています。建材選定時に第三者認証に指定する場合は、第三者認証のみで検索してください。
              </Typography>
            </Box>
          </Box>
        </Container>
      </Dialog>
    </>
  );
};

export default CustomDialog;
